module.exports = __webpack_public_path__ + "static/media/5.056781f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/5.png
// module id = 2112
// module chunks = 0